import http from '@/plugins/http';
import oneJobUpdatedTransformer from '../../transformers/job/oneJobUpdate';

export default (job) => new Promise((res, rej) => {
  const transformedJob = oneJobUpdatedTransformer.send(job);
  http.put(`/v3/jobs/${job.id}`, transformedJob)
    .then((response) => {
      res(response.data);
    })
    .catch((error) => {
      rej(error);
    });
});
